export interface ReviewsPageContent {
  hero: {
    backgroundImage: string
    title: string
    subtitle: string
  }
  trustpilotBusinessUnitId: string
  trustpilotCTA: string
}

const content: ReviewsPageContent = {
  hero: {
    backgroundImage: '/images/shipsticks/hero-background.jpg',
    title: "Thousands of travelers trust us. Here's why.",
    subtitle:
      'Read real reviews from travelers who shipped their luggage and gear ahead, ditched ' +
      'the baggage claim, and never looked back.',
  },
  trustpilotBusinessUnitId: '64d2a1e83c1d791bdb53f191',
  trustpilotCTA: 'View all of Ship&Play real customer reviews on TrustPilot',
}

/**
 * Copy for the Ship&Play port (see ShipplayReviewsPage). Kept here so the page
 * component owns only the render tree, matching the other Ship&Play pages.
 */
export interface ShipplayReviewsContent {
  hero: {
    imgUrl: string
    title: { prefix: string; emphasis: string }
    subheading: string
  }
}

export const shipplayContent: ShipplayReviewsContent = {
  hero: {
    imgUrl: '/images/shipplay/hero/about-us.webp',
    title: {
      prefix: 'Thousands of Travelers Trust Us.',
      emphasis: 'Here’s Why',
    },
    subheading:
      'Real reviews from real people who ditched the baggage claim and never looked back.',
  },
}

export default content
